export class LayoutField {
    public FieldName: string;
    public FieldTitle: string;
    public NoLabel: boolean = false;
    public AlternativeView: boolean = false;
    public Hidden: boolean = false;
    public BoldLabel: boolean = false;
    public TextColor: string = '#333';
}